import React from "react";
import { observer } from "mobx-react-lite";
import { Avatar, useTheme } from "@ugc-ui/lego";
import { useStores } from "@client/store";
import { useDropDownMenuState } from "@src/common/hooks/useDropDownMenuState";
import { useIsMobile } from "@src/common/hooks/isMobile";
import { ProfileMenuStyled } from "./ProfileMenu.styled";
import { ProfileMenuSharedContent } from "../ProfileMenuSharedContent/ProfileMenuSharedContent";
import { FullScreenModalProfileMenu } from "../FullScreenModalProfileMenu/FullScreenModalProfileMenu";

type Props = {
  avatar: string;
};

export const ProfileMenu: React.FC<Props> = observer(({ avatar }) => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const {
    client: {
      fullScreenProfileDialogStore: { openDialog: handleOpenFullScreenDialog },
    },
  } = useStores();

  const {
    isOpen,
    handleOpenMenu: openDropdownMenu,
    handleCloseMenu,
  } = useDropDownMenuState();

  const handleOpenMenu = () => {
    // eslint-disable-next-line no-unused-expressions
    isMobile ? handleOpenFullScreenDialog() : openDropdownMenu();
  };

  return (
    <>
      <Avatar src={avatar} dataCy="профиль - аватар" onClick={handleOpenMenu} />

      <ProfileMenuStyled
        open={isOpen}
        onClose={handleCloseMenu}
        theme={theme}
        menuContent={<ProfileMenuSharedContent />}
      />
      <FullScreenModalProfileMenu />
    </>
  );
});
